import { render, staticRenderFns } from "./AgencyBuyDomain.vue?vue&type=template&id=b4e2261e"
import script from "./AgencyBuyDomain.vue?vue&type=script&lang=js"
export * from "./AgencyBuyDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports